import { render, staticRenderFns } from "./batchLog.vue?vue&type=template&id=9b084dca"
import script from "./batchLog.vue?vue&type=script&lang=js"
export * from "./batchLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b084dca')) {
      api.createRecord('9b084dca', component.options)
    } else {
      api.reload('9b084dca', component.options)
    }
    module.hot.accept("./batchLog.vue?vue&type=template&id=9b084dca", function () {
      api.rerender('9b084dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/log/batchLog.vue"
export default component.exports